import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewAno, UpdateAno } from "../../Services/ano-services";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import { isAlphanumericWithDot, isAlphanumericWithSpaceandDash } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import ButtonModal from "../Modals/buttonModal";

const AddEditAnoMaster = (props) => {
  if (props.rowdata.wld_status === "Active") {
    props.rowdata.wld_status = true;
  } else if (props.rowdata.wld_status === "Inactive") {
    props.rowdata.wld_status = false;
  }
  let action = props.action;
  let formName = "A No.";
  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const toggle = props.rowdata.wld_status === false ? "InactiveToggleLabel" : "activeToggleLabel";
  const [toggleClass, setToggleClass] = useState(action === "Edit" ? toggle : "activeToggleLabel");
  const [alertMessage, setAlertMessage] = useState("");
  const history = useNavigate();
  let username = sessionStorage.getItem("UserName");
  const [AnoObj, setAnoObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_status: true,
        wld_code: "",
        wld_description: "",
        SK: "",
        PK: "Ano",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
      }
  );
  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_description: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
  });
  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setAno",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };
  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAnoObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }

    setAnoObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setAnoObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_code: "",
        wld_description: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
      }));
      setToggleClass("activeToggleLabel");
    } else if (action === "Edit") {
      setAnoObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_code: props.rowdata.wld_code,
        wld_description: props.rowdata.wld_description,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
      }));
      setToggleClass(props.rowdata.wld_status ? "activeToggleLabel" : "inactiveToggleLabel");
    }
    setError((prevState) => ({
      ...prevState,
      wld_code: {},
      wld_description: {},
      SK: {},
    }));
  };

  const validateAno = (action) => {
    let result = false;
    let isError = false;

    if (AnoObj.wld_code.trim() === "") {
      AnoObj.wld_code = "";
      isError = true;
      error.wld_code = {
        status: true,
        message: "Ano Code is required.",
      };
    }
    if (AnoObj.wld_description.trim() === "") {
      AnoObj.wld_description = "";
      isError = true;
      error.wld_description = {
        status: true,
        message: "Ano Description is required.",
      };
    }

    if (AnoObj.wld_status === "") {
      isError = true;
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
    }

    if (action === "Add") {
      result = props.allRecs?.find((item) =>
        item.PK.toLowerCase() === AnoObj.PK.toLowerCase() &&
        item.SK.toLowerCase() === AnoObj.wld_code.toLowerCase()
      );
    }

    if (result) {
      setAlertMessage("Ano Number Already Exists!");
      isError = true;
    }

    setError((prevState) => ({
      ...prevState,
      ...error,
    }));

    if (
      error.SK.status ||
      error.wld_code.status ||
      error.wld_description.status
    ) {
      isError = true;
    }
    return isError;
  };

  const handleAdd = (e) => {
    let result;
    if (AnoObj.wld_status === true) {
      AnoObj.wld_status = "Active";
    } else {
      AnoObj.wld_status = "Inactive";
    }
    if (action === "Add") {
      AnoObj.SK = AnoObj.wld_code;
      AnoObj.wld_createdby = username;

      result = AddNewAno(AnoObj);
    } else {
      AnoObj.wld_updatedby = AnoObj.wld_createdby;

      result = UpdateAno(AnoObj);
    }
    result
      .then((resp) => {
        if (action === "Edit") {
          showSuccess(`Selected A No. has been Updated successfully`);
        }

        if (resp.message === "Duplicate") {
          showWarning(resp.message);
        } else if (action === "Add") {
          showSuccess(`Selected A No. has been Added successfully`);
        }
        props.setReload(!props.reload);
        setShowForm(false);
        props.onHide();
      })
      .catch((error) => {
        console.log("Failed");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateAno(action)) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Ano successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} A No. </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_code"
                        name="wld_code"
                        placeholder=" "
                        disabled={action === "Edit" ? true : false}
                        maxLength="3"
                        className={
                          error.wld_code.status
                            ? " g-input placeHolderInput inputText text-field-with-error allow"
                            : "g-input placeHolderInput inputText allow"
                        }
                        value={AnoObj.wld_code}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithDot(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_code: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_code">
                        A No.
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_code.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "20px" }}>
                          {error.wld_code.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_description"
                        name="wld_description"
                        type="text"
                        maxLength="100"
                        className={`asterisk ${error.wld_description.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={AnoObj.wld_description}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithSpaceandDash(
                            e.target.value
                          );
                          setError((prevState) => ({
                            ...prevState,
                            wld_description: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_description">
                        A No. Description
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_description.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "10px" }}>
                          {error.wld_description.message}
                        </span>{" "}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={AnoObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {AnoObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditAnoMaster;